'use client'

import React from 'react'
import { useParams } from 'next/navigation'
import type { InitialResults } from 'instantsearch.js'
import { FacetConfiguration } from 'components/commercetools-ui/organisms/product/product-list-algolia/types'
import CustomProductListAlgoliaWrapper from 'components/ui/custom-product-list-algolia/wrapper'
import { FacetValuesByAttribute } from 'helpers/algolia/parsePlFacetUrlParams'
import type { SupportedLocale } from 'providers/algolia/localized-index/indexMap'
import { ContentstackQueryBuilder, getParsedFilterQueries } from './AlgoliaQueryBuilderDataProvider'

interface ContentstackAlgoliaQueryBuilderProps extends ContentstackAlgoliaQueryBuilder {
  preloadedData?: {
    products: InitialResults
    facetValues: FacetValuesByAttribute
    facetsConfiguration: Record<string, FacetConfiguration>
  }
}

const ContentstackAlgoliaQueryBuilder = ({
  algolia_filters,
  preloadedData,
}: ContentstackAlgoliaQueryBuilderProps) => {
  const params = useParams()
  const locale = (params?.locale as SupportedLocale) || 'de-DE'
  const filter = getParsedFilterQueries((algolia_filters as unknown as ContentstackQueryBuilder)?.filterQueries, locale)

  return (
    <CustomProductListAlgoliaWrapper
      searchQuery=""
      category={undefined}
      contentstackPLP={undefined}
      flattenedCategories={undefined}
      filter={filter}
      preloadedData={preloadedData?.products}
      initialResults={preloadedData?.products}
      facetValues={preloadedData?.facetValues}
      facetsConfiguration={preloadedData?.facetsConfiguration ?? {}}
    />
  )
}

export default ContentstackAlgoliaQueryBuilder
